module.exports = __webpack_public_path__ + "img/SeeingIllusions.2c37f5ee.jpg";